import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useIsMobile } from "../hooks/use-mobile";
import MainLayout from "../components/MainLayout";
import HomeRightSidebar from "../components/home_components/HomeRightSidebar";
import SocialPostCard from "../components/home_components/SocialPostCard";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { getPostingById } from "../services/scoops";
// Dummy following users data - you might want to fetch this from an API too
const dummyFollowingUsers = ["user456", "user789", "user101"];

export default function SinglePostPage() {
  const { id: postId } = useParams();
  const isMobile = useIsMobile();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [followingUsers, setFollowingUsers] = useState(dummyFollowingUsers);

  useEffect(
    () => {
      const fetchPost = async () => {
        if (!postId) {
          setError("No post ID provided");
          setLoading(false);
          return;
        }

        try {
          setLoading(true);
          setError(null);
          const response = await getPostingById(postId);
          console.log(response, "response");
          if (response && response.status === "success" && response.data) {
            const transformedPost = {
              id: response.data.postingid,
              postingid: response.data.postingid,
              userid: response.data.userid,
              username: response.data.username,
              avatar_url:
                response.data.avatar_url ||
                "/placeholder.svg?height=40&width=40",
              contentinfo: response.data.contentinfo,
              photopath: response.data.photopath,
              createdate: response.data.createdate,
              updatedate: response.data.updatedate,
              scoopname: response.data.scoopname,
              scoopid: response.data.scoopid,
              hoopids: response.data.hoopids || [],
              hoops: response.data.hoops || [],
              totalLikes: parseInt(response.data.totalLikesResult) || 0,
              totalLikesResult: response.data.totalLikesResult,
              likes: response.data.likes || [],
              userLikes: response.data.userLikes,
              geohash: response.data.geohash,
              groupid: response.data.groupid,
              status: response.data.status,
              updatedby: response.data.updatedby,
              comments: [],
              shares: 0,
              reposts: 0
            };
            setPost(transformedPost);
          } else {
            setError("Post not found or invalid response");
          }
        } catch (err) {
          console.error("Error fetching post:", err);
          setError(err.message || "Failed to load post");
        } finally {
          setLoading(false);
        }
      };

      fetchPost();
    },
    [postId]
  );


  const handlePostUpdate = async () => {
    try {
      const response = await getPostingById(postId);
      if (response && response.status === "success" && response.data) {
        const transformedPost = {
          id: response.data.postingid,
          postingid: response.data.postingid,
          userid: response.data.userid,
          username: response.data.username,
          avatar_url:
            response.data.avatar_url || "/placeholder.svg?height=40&width=40",
          contentinfo: response.data.contentinfo,
          photopath: response.data.photopath,
          createdate: response.data.createdate,
          updatedate: response.data.updatedate,
          scoopname: response.data.scoopname,
          scoopid: response.data.scoopid,
          hoopids: response.data.hoopids || [],
          hoops: response.data.hoops || [],
          totalLikes: parseInt(response.data.totalLikesResult) || 0,
          totalLikesResult: response.data.totalLikesResult,
          likes: response.data.likes || [],
          userLikes: [],
          geohash: response.data.geohash,
          groupid: response.data.groupid,
          status: response.data.status,
          updatedby: response.data.updatedby,
          comments: [],
          shares: 0,
          reposts: 0
        };
        setPost(transformedPost);
      }
    } catch (err) {
      console.error("Error updating post:", err);
    }
  };

  // Loading state
  if (loading) {
    return (
      <MainLayout
        rightSidebar={
          !isMobile ? (
            <HomeRightSidebar
              onClick={() => console.log("Create event clicked")}
            />
          ) : null
        }
      >
        <div className="">
          {/* Header */}
          <div className="flex items-center mb-6">
            <Link to="/home" className="mr-4">
              <ArrowLeft className="h-6 w-6 text-gray-600 hover:text-gray-900" />
            </Link>
            <h1 className="text-xl font-semibold">Post</h1>
          </div>

          {/* Loading skeleton */}
          <div className="bg-white rounded-lg shadow-sm p-6 animate-pulse">
            <div className="flex items-center mb-4">
              <div className="h-10 w-10 bg-gray-200 rounded-full mr-3" />
              <div>
                <div className="h-4 bg-gray-200 rounded w-24 mb-2" />
                <div className="h-3 bg-gray-200 rounded w-32" />
              </div>
            </div>
            <div className="h-4 bg-gray-200 rounded w-full mb-2" />
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-4" />
            <div className="h-64 bg-gray-200 rounded-lg mb-4" />
            <div className="flex items-center space-x-4">
              <div className="h-8 bg-gray-200 rounded w-16" />
              <div className="h-8 bg-gray-200 rounded w-20" />
            </div>
          </div>
        </div>
      </MainLayout>
    );
  }

  // Error state
  if (error) {
    return (
      <MainLayout
        rightSidebar={
          !isMobile ? (
            <HomeRightSidebar
              onClick={() => console.log("Create event clicked")}
            />
          ) : null
        }
      >
        <div className="">
          <div className="flex items-center mb-6">
            <Link to="/home" className="mr-4">
              <ArrowLeft className="h-6 w-6 text-gray-600 hover:text-gray-900" />
            </Link>
            <h1 className="text-xl font-semibold">Post</h1>
          </div>
          <div className="text-center py-8">
            <h2 className="text-xl font-semibold text-red-600 mb-2">
              Error Loading Post
            </h2>
            <p className="text-gray-500 mb-4">{error}</p>
            <button
              onClick={() => window.location.reload()}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors mr-4"
            >
              Try Again
            </button>
            <Link
              to="/home"
              className="text-blue-600 hover:text-blue-800 inline-block"
            >
              Go back to home
            </Link>
          </div>
        </div>
      </MainLayout>
    );
  }

  // Post not found state
  if (!post) {
    return (
      <MainLayout
        rightSidebar={
          !isMobile ? (
            <HomeRightSidebar
              onClick={() => console.log("Create event clicked")}
            />
          ) : null
        }
      >
        <div className="">
          <div className="flex items-center mb-6">
            <Link to="/home" className="mr-4">
              <ArrowLeft className="h-6 w-6 text-gray-600 hover:text-gray-900" />
            </Link>
            <h1 className="text-xl font-semibold">Post</h1>
          </div>
          <div className="text-center py-8">
            <h2 className="text-xl font-semibold text-gray-600 mb-2">
              Post not found
            </h2>
            <p className="text-gray-500">
              The post you're looking for doesn't exist.
            </p>
            <Link
              to="/home"
              className="text-blue-600 hover:text-blue-800 mt-4 inline-block"
            >
              Go back to home
            </Link>
          </div>
        </div>
      </MainLayout>
    );
  }

  // Success state - render the post
  return (
    <MainLayout
      rightSidebar={
        !isMobile ? (
          <HomeRightSidebar
            onClick={() => console.log("Create event clicked")}
          />
        ) : null
      }
    >
      <div>
        {/* Header */}
        <div className="flex items-center mb-6">
          <Link
            to="/home"
            className="mr-4 hover:bg-gray-100 p-2 rounded-full transition-colors"
          >
            <ArrowLeft className="h-6 w-6 text-gray-600 hover:text-gray-900" />
          </Link>
          <h1 className="text-xl font-semibold">Post</h1>
        </div>

        {/* Single Post */}
        <div className="max-w-2xl mx-auto">
          <SocialPostCard
            post={post}
            postFetcher={handlePostUpdate}
            followingUsers={followingUsers}
            isMobile={isMobile}
            images={post.photopath ? post.photopath.split(",") : []}
            className="mb-0"
            showComments={true}
          />
        </div>
      </div>
    </MainLayout>
  );
}
